import Gallery from '@jetshop/ui/Gallery/Gallery';
import SearchVariantGallery from '../../Theme/SearchVariantGallery';
import Badges from '@jetshop/ui/ProductList/Badges';
import React from 'react';
import styled from 'react-emotion';
import { Query } from 'react-apollo';
import gql from '@jetshop/core/gql';

const Wrapper = styled('div')`
display: flex;
flex-direction: column;

.image-gallery-fullscreen-button {
  color: black !important;
  text-align: center;
  &:before {
    margin: 0 auto;
    color: black !important;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    font-size: 1rem !important;
  }
  @supports (-ms-accelerator: true) {
    font-size: 1rem !important;
  }
}

.image-gallery-slide {
  //background-color: ${({ theme }) => theme.colors.themeGrey} !important;
}

.image-gallery-thumbnails-wrapper {
  width: 88px;
}

.image-gallery-thumbnails {
  justify-content: flex-start !important;
  a {
    width: 100%;
    //background-color: ${({ theme }) => theme.colors.themeGrey};
    border: none;
    opacity: 0.5;
    &.active {
      opacity: 1;
    }
  }
}

${({ theme }) => theme.below.md} {
  .image-gallery {
    & > .image-gallery-content {
      display: flex;
      flex-direction: column;
      & > .image-gallery-thumbnails-wrapper {
        width: 100%;
        height: 20px !important;
        order: 2;
        margin-top: 10px;
        text-align: center;
        & > div {
          position: relative;
        }
        a {
          display: inline-block;
          width: 14px;
          height: 14px;
          margin: 0 8px;
          border-radius: 50%;
          border: 2px solid ${({ theme }) => theme.colors.themeBlack};
          opacity: 1;
          &.active {
            background-color: ${({ theme }) => theme.colors.themeBlack};
          }
          & > div {
            display: none;
          }
        }
      }
      & > .image-gallery-slide-wrapper {
        order: 1;
        width: 100% !important;
        //min-height: 374px;
        margin: 0 auto;
        margin-bottom: 1rem;
        .image-gallery-image > div {
          height: 58vh;
          background-size: cover;
        }
      }
    }
  }
}
`;

export default function ImageContainer({ images, badges, product, ...rest }) {
  const rawArticleNumber = product.articleNumber;
  const articleNumber = rawArticleNumber.substring(0, 8);

  return (
    <Query query={GET_PRODUCT_VARIANTS} variables={{ articleNumber }}>
      {({ data, loading }) => {
        if (loading) return '';
        const GalleryType =
          data && data.search.products.result.length > 1
            ? SearchVariantGallery
            : Gallery;
        return (
          <Wrapper {...rest}>
            <GalleryType
              variants={data.search.products.result}
              product={product}
              images={images}
              aspect={'1:1'}
              thumbnailPosition={'left'}
            >
              <Badges badges={badges} />
            </GalleryType>
          </Wrapper>
        );
      }}
    </Query>
  );
}

const routecrumbFragment = gql`
  fragment Routecrumb on Route {
    id
    path
    slug
    object {
      breadcrumbText
    }
    parents {
      id
      path
      slug
      object {
        breadcrumbText
      }
    }
  }
`;

const GET_PRODUCT_VARIANTS = gql`
query getProductVariants($articleNumber: String!) {
  search(term: $articleNumber) {
    products {
      result {
        id
        name
        articleNumber
        primaryRoute {
          ${routecrumbFragment}
        }
        customFields {
          title
          ... on CustomStringField {
            stringValue: value
          }
        }
        images {
          alt
          title
          url
        }
      }
    }
  }
}
`;
